// extracted by mini-css-extract-plugin
module.exports = {"delta2Pc":"Delta2new_delta2Pc__6NqAm","delta2H5":"Delta2new_delta2H5__5Ezpa"};